<template>
  <div class="page content-page">

    <div class="columns">
      <div class="column">
          
          <h1>Impressum</h1>
      </div>
    </div>
    <div class="columns flex wrap">

      <div class="column">
        <p>Peter Köhler GmbH & Co KG<br/>
        Bergische Landstr. 86<br/>
        40629 Düsseldorf<br/>
        <br/>
        Telefon: 0211-6016020<br/>
        Telefax: 0211-296372<br/>
        E-mail: info@koehler-klinker.de<br/>
        Internet: www.koehler-klinker.de<br>
            <a class="button" href="tel:+492116016020">Anrufen</a>
            <a class="button" href="mailto:info@koehler-klinker.de">E-Mail schreiben</a>
             <a class="button" href="https://www.koehler-klinker.de" target="_blank" rel="noopener">Zur Website von köhler.</a>
            </p>
        
        <p>
        Persönlich haftende Gesellschafter:<br/>
        Hans-Theo Köhler GmbH<br/>
        Vertretungsberechtigter Geschäftsführer:<br/>
        Thomas Köhler<br/>
        <br/>
        Registergericht: Amtsgericht Düsseldorf<br/>
        Registernummer: HRA 3605<br/>
        Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz: DE121286881<br/>
        <br/>
        Inhaltlich Verantwortlicher gemäß § 10 Absatz 3 MDStV:<br/>
        Thomas Köhler<br/>
        <br/>
        Showroom Konzept:<br/>
        Architektur Sievert/Leister, Düsseldorf<br/>
        <br/>
        Markenentwicklung, Konzept, Umsetzung:<br/>
        DO BETTER THINGS UG (haftungsbeschränkt)<br><a class="button" href="https://www.dobetterthings.de">dobetterthings.de</a><br/>
        <br/>
        Haftungshinweis:<br/>
        Trotz sorgfältiger inhaltlicher Kontrolle übernehmen wir keine Haftung für die Inhalte externer Links. Für den Inhalt der verlinkten Seiten sind ausschließlich deren Betreiber verantwortlich.
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
    name: 'AboutPage',
    data: function(){
      return {
         }
    },
    methods: {},
    created: function(){
    },
    mounted: function(){},
    computed: {}
}  
</script>
<style>
</style>